<table class="mdl-data-table mdl-js-data-table mdl-data-table--selectable mdl-shadow--2dp monitoring-table">
    <thead>
        <tr>
            <th style="width: 5%" class="header-cell">#</th>
            <th style="width: 10%" class="header-cell">Id</th>
            <th style="width: 15%" class="header-cell">Event Type</th>
            <th style="width: 20%" class="header-cell">Process Id</th>
            <th style="width: 15%" class="header-cell">Process Type</th>
            <th style="width: 25%" class="header-cell">User</th>
            <th style="width: 10%" class="header-cell">Created</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let event of eventsList; let i = index" app-zoning-code-event-row [event]="event" [index]="i+1"
            [stateEnv]="stateEnv">
        </tr>
    </tbody>
</table>